import React from 'react';
import PropTypes from 'prop-types';

import {Grid, Stack} from 'views/components';

import JobTitle from './JobTitle';
import PayAndHoursCard from './PayAndHoursCard';
import RequiredDaysCard from './RequiredDaysCard';
import DescriptionCard from './DescriptionCard';
import StartDateCard from './StartDateCard';
import LocationCard from './LocationCard';
import CareNeedsCard from './CareNeedsCard';
import RequirementsCard from './RequirementsCard';
import AdditionalConsiderationsCard from './AdditionalConsiderationsCard';

const JobDetailMainColumn = (props) => {
  const {jobDataParsed, startDate, requirements, location, description} = props;

  return (
    <Grid size={{xs: 12, lg: 8}}>
      <Stack spacing={2.25} sx={{maxWidth: 560}}>
        <JobTitle location={location} requirements={requirements} jobDataParsed={jobDataParsed} />

        <DescriptionCard description={description} />
        <PayAndHoursCard jobDataParsed={jobDataParsed} />
        <RequiredDaysCard jobDataParsed={jobDataParsed} />

        <StartDateCard startDate={startDate} />
        <LocationCard location={location} />

        <CareNeedsCard requirements={requirements} />
        <RequirementsCard requirements={requirements} />

        <AdditionalConsiderationsCard requirements={requirements} />
      </Stack>
    </Grid>
  );
};

JobDetailMainColumn.propTypes = {
  jobDataParsed: PropTypes.object,
  startDate: PropTypes.object,
  requirements: PropTypes.object,
  location: PropTypes.object,
  description: PropTypes.object,
};

export default JobDetailMainColumn;
